import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import type { Option } from '#pie/components/input-dropdown/InputDropdown';
import { useGetGridOperator } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

export const gridOperatorValidationSchema = z.object({
  regionalGridOperatorId: z.string().min(1),
});

type GridOperatorForm = z.infer<typeof gridOperatorValidationSchema>;

const { FormDropdown } = typedFormFields<GridOperatorForm>();

type Props = Pick<ComponentProps<typeof FormDropdown>, 'disabled'> & {
  selectedOption?: Option;
};

export const TicketGridOperatorsFields = ({
  disabled,
  selectedOption,
}: Props) => {
  const { t } = useTranslation();
  const { data: gridOperatorData, isLoading: isLoadingGridOperators } =
    useGetGridOperator();
  return (
    <FormDropdown
      fullWidth
      label={t('common.regional_grid_operator')}
      name="regionalGridOperatorId"
      options={
        selectedOption
          ? [selectedOption]
          : gridOperatorData?.items.map((operator) => ({
              label: operator.name,
              value: operator.id,
            })) || []
      }
      rules={{ required: true }}
      isLoading={isLoadingGridOperators}
      disabled={disabled}
    />
  );
};
